<div>
  <div class="weighting__page" *ngIf="weightResultDetails?.WEIGHT_CALC_LIST">

    <div class="row mb-4">
      <div class="col-lg-10 col-md-12">
        <div class="color-secondary-gray font-size-16 font-weight-normal mb-3">
          <div>A summary of the historical revenue and cashflow is presented below. Keeping in mind that 'valuation is a prophecy as to the future',
            our system has analyzed the historical revenues and SDE and calculated a weighting that will be used as a benchmark to estimate the future revenues and SDE.
            You may edit the outlier years and weighting below, if you choose to do so.</div>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col-lg-3 col-md-4 col-6 table-side-container">
        <div class="header top">
          <div class="mobile-buttons">
            <ng-container [ngTemplateOutlet]="manualOverrideButtons"></ng-container>
          </div>
        </div>
        <div class="header color--basic--black--imp">
          Outlier Years
          <span class="hide-show-button" *ngIf="outlierVisible" (click)="outlierVisible = !outlierVisible"><i class="fa fa-eye-slash"></i> Hide</span>
          <span class="hide-show-button" *ngIf="!outlierVisible" (click)="outlierVisible = !outlierVisible"><i class="fa fa-eye"></i> Show</span>
        </div>
        <div class="header">Revenue</div>
        <div class="header">Seller's Discretionary Earnings (SDE)</div>
      </div>

      <div class="col-lg-7 col-md-5 col-6">
        <div class="row flex-nowrap table__body custom__scroll vertical__Scroll overflow-y-hidden">
          <div class="col-lg-3 col-md-12 col-12 p-0 table-column border-first-left" *ngFor="let ist of weightResultDetails?.WEIGHT_CALC_LIST; let i = index">

            <!-- Header -->
            <div class="table-column-header top">
              <div>{{ist.YEAR}}</div>
              <div class="color-secondary-gray font-size-12">{{reportService.changeTextStyle(ist.FINANCIAL_TYPE)}}</div>
            </div>

            <!-- Outlier Years -->
            <div class="table-column-header align-items-center">
              <!--<label class="checkbox large m-0 w-100">
                <input class="checkbox__input" type='checkbox' name="{{'OutlierYearsCheckName' + i}}"
                       [(ngModel)]="ist.OUTLIER"
                       [disabled]="ist.MONTHS != 12 || ist.FINANCIAL_TYPE == 'NOT_AVAILABLE' || currentReport?.isLocked || currentReport?.LATEST?.WEIGHTINGS_ADVANCED"
                       (change)="ist.WEIGHT = 0; callUpdateGroupAPI(ist);" tabindex="-1" />
                <div class="checkbox__data">
                  <div class="checkbox__indicator"></div>
                  <p class="checkbox__text">Set as outlier</p>
                </div>
              </label>-->
              <ng-container *ngIf="outlierVisible">
                <div class="custom-control custom-switch">
                  <input type="checkbox" class="custom-control-input" id="{{'customSwitch' + i}}" name="{{'OutlierYearsCheckName' + i}}"
                         [(ngModel)]="ist.OUTLIER"
                         [disabled]="ist.MONTHS != 12 || ist.FINANCIAL_TYPE == 'NOT_AVAILABLE' || currentReport?.isLocked || currentReport?.LATEST?.WEIGHTINGS_ADVANCED"
                         (change)="ist.WEIGHT = 0; callUpdateGroupAPI(ist);" tabindex="-1" />
                  <label class="custom-control-label checkbox__text" for="{{'customSwitch' + i}}">
                    Set as outlier
                  </label>
                </div>
              </ng-container>
            </div>

            <!-- REVENUE -->
            <div class="table-column-cell weight__column">
              <div class="d-flex align-items-center">
                <div class="w-60">

                  <number-input [(ngModel)]="ist.REVENUE" [classes]="'input silent-input'" #REVENUE="ngModel"
                    [required]="false" name="REVENUE_{{i}}" (blur)="callUpdateAPI('REVENUE', ist)"
                    [disabled]="(!isEditMode && 1 == 1) || currentReport?.isLocked || (ist.FINANCIAL_TYPE == financialTypeEnum.FORECASTED && currentReport.LATEST.ASSISTED_INTERIM_CALCULATION)"
                    id="REVENUE_{{i}}"></number-input>

                </div>
                <ng-container>
                  <div class="percentage position-relative text-center" *ngIf="ist.REVENUE_CHANGE != null"
                    [ngClass]="{'negative': ist.REVENUE_CHANGE < 0, 'positive': ist.REVENUE_CHANGE > 0}">
                    <div class="yoyBadge"
                         [popover]="'Year over year change of ' + currencyPipe.transform(ist.REVENUE_CHANGE) + '% from ' + weightResultDetails?.WEIGHT_CALC_LIST[i - 1]?.YEAR + ' to ' + ist.YEAR"
                         triggers="mouseenter:mouseleave" [placement]="'top'" [adaptivePosition]="true" container="body">
                      YoY
                    </div>
                    <span *ngIf="ist.REVENUE_CHANGE > 999">>999%</span>
                    <span *ngIf="ist.REVENUE_CHANGE <= 999">{{ist.REVENUE_CHANGE ||
                      0}}%</span>
                  </div>
                  <div class="percentage text-center" *ngIf="ist.REVENUE_CHANGE == null">
                    N/A
                  </div>
                </ng-container>
              </div>
            </div>

            <!-- SDE -->
            <div class="table-column-cell weight__column last-border">
              <div class="d-flex align-items-center">
                <div class="w-60">

                  <number-input [(ngModel)]="ist.SDE" [classes]="'input silent-input'" #SDE="ngModel" [required]="false"
                    name="SDE_{{i}}" [disabled]="true" id="SDE_{{i}}"></number-input>

                </div>
                <ng-container>
                  <div class="percentage position-relative text-center" *ngIf="ist.SDE_CHANGE != null"
                    [ngClass]="{'negative': ist.SDE_CHANGE < 0, 'positive': ist.SDE_CHANGE > 0}">
                    <div class="yoyBadge"
                         [popover]="'Year over year change of ' + currencyPipe.transform(ist.SDE_CHANGE) + '% from ' + weightResultDetails?.WEIGHT_CALC_LIST[i - 1]?.YEAR + ' to ' + ist.YEAR"
                         triggers="mouseenter:mouseleave" [placement]="'top'" [adaptivePosition]="true" container="body">
                      YoY
                    </div>
                    <span *ngIf="ist.SDE_CHANGE > 999">>999%</span>
                    <span *ngIf="ist.SDE_CHANGE <= 999">{{ist.SDE_CHANGE || 0}}%</span>
                  </div>
                  <div class="percentage text-center" *ngIf="ist.SDE_CHANGE == null">
                    N/A
                  </div>
                </ng-container>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-lg-2 col-md-3 col-12 align-self-end">
        <div class="desktop-buttons">
          <ng-container [ngTemplateOutlet]="manualOverrideButtons"></ng-container>
        </div>
        <div class="total--box" *ngIf="currentReport && currentReport.LATEST">
          <div class="weighted-revenue">
            <div class="font-weight-bold color-secondary-gray font-size-12">Weighted Revenue</div>
            <div class="font-weight-bold color--blue font-size-16">${{currentReport.LATEST.WEIGHTED_REVENUE | number}}</div>
          </div>
          <div class="mt-10 weighted-sde">
            <div class="font-weight-bold color-secondary-gray font-size-12">Weighted SDE</div>
            <div class="font-weight-bold color--blue font-size-16">${{currentReport.LATEST.WEIGHTED_SDE | number}}</div>
          </div>
        </div>
      </div>

    </div>

    <ng-template #manualOverrideButtons>
      <div class="align-self-center text-center" *ngIf="!noYearsRender && weightingsVisible">
        <button id="help-me-calculate-btn" class="button primary__button small__button half-rounded__button"
                *ngIf="!currentReport.LATEST.WEIGHTINGS_ADVANCED" (click)="changeAutomaticallyManually()"
                [disabled]="currentReport?.isLocked">
          Help me Calculate
        </button>

        <button id="manual-overrides-btn"
                class="button secondary__button blue__bordered__button small__button half-rounded__button"
                *ngIf="currentReport.LATEST.WEIGHTINGS_ADVANCED" (click)="changeAutomaticallyManually()"
                [disabled]="currentReport?.isLocked">
          Manually Override
        </button>
      </div>
    </ng-template>

    <!-- Validation Error -->
    <div class="mt-2 text-right color--red font-size-14"
      *ngIf="weightResultDetails?.WEIGHT_CALC_LIST && !checkValidation()">
      * Atleast one non-outliers required and Sum of non-outliers weightings should be 100%
    </div>

    <!-- Chart -->
    <div class="row mt-5" *ngIf="renderChart">
      <div class="col-lg-2 col-md-3">
        <span class="font-size-16 font-weight-bold color--basic--black">Graph</span>
        <span class="hide-show-button" *ngIf="chartVisible" (click)="chartVisible = !chartVisible"><i class="fa fa-eye-slash"></i> Hide</span>
        <span class="hide-show-button" *ngIf="!chartVisible" (click)="chartVisible = !chartVisible"><i class="fa fa-eye"></i> Show</span>

        <div *ngIf="!noYearsRender && chartVisible">
          <div class="legend--box">
            <div class="color--box bg--color--black"></div> <div>Revenue</div>
          </div>
          <div class="legend--box">
            <div class="color--box bg--color--blue"></div> <div>SDE</div>
          </div>
        </div>
      </div>
      <div class="col-lg-8 col-md-9 chart--box" *ngIf="!noYearsRender && chartVisible">
        <canvas baseChart width="800" height="300" style="display: inline;" [data]="chartDataNew"
          [labels]="chartLabels" [legend]="false" [options]="barChartOptions" [type]="'bar'">
        </canvas>
      </div>

      <div class="col-md-10" *ngIf="noYearsRender">
        <p>There is no Years to Show in Graph</p>
      </div>
    </div>

    <!-- Weightings -->
    <div class="row my-5">
      <div class="col-lg-3 col-md-4 table-side-container">
        <div class="header"></div>
        <div class="header color--basic--black--imp">
          Weightings
          <span class="hide-show-button" *ngIf="weightingsVisible" (click)="weightingsVisible = !weightingsVisible"><i class="fa fa-eye-slash"></i> Hide</span>
          <span class="hide-show-button" *ngIf="!weightingsVisible" (click)="weightingsVisible = !weightingsVisible"><i class="fa fa-eye"></i> Show</span>
        </div>
      </div>

      <div class="col-lg-7 col-md-8" *ngIf="weightingsVisible">
        <div class="row flex-nowrap table__body custom__scroll vertical__Scroll overflow-y-hidden">
          <div class="col-lg-3 col-md-4 p-0 table-column border-first-left" *ngFor="let ist of weightResultDetails?.WEIGHT_CALC_LIST; let i = index">

            <div class="table-column-header align-items-center font-size-16__imp">
              {{ist.YEAR}}
            </div>
            <div class="table-column-cell weight__column last-border">
              <div class="d-flex align-items-center">

                <number-input id="{{'weightings-advanced'+i}}" *ngIf="ist.MONTHS == 12"
                              classes="input silent-input" [min]="0" [max]="100" [allowZero]="true" [clearZero]="false"
                              [disabled]="ist.OUTLIER || currentReport.LATEST.WEIGHTINGS_ADVANCED || ist.FINANCIAL_TYPE == 'NOT_AVAILABLE' || currentReport?.isLocked"
                              [(ngModel)]="ist.WEIGHT" (blur)="ist.WEIGHT <= 100 ? callUpdateAPI('WEIGHT', ist) : null"
                              [needPercentFormatter]="true"></number-input>

                <!--<input type="text" id="{{'weightings-advanced'+i}}" *ngIf="ist.MONTHS == 12" percentFormatter
                       class="input silent-input" maxlength="3" min="0" max="100"
                       [disabled]="ist.OUTLIER || currentReport.LATEST.WEIGHTINGS_ADVANCED || ist.FINANCIAL_TYPE == 'NOT_AVAILABLE' || currentReport?.isLocked"
                       [(ngModel)]="ist.WEIGHT" (blur)="ist.WEIGHT <= 100 ? callUpdateAPI('WEIGHT', ist) : null"
                       (focus)="onPercentageFocus(ist)" (focusout)="onPercentageFocus(ist)" numbersOnly>-->
                <input type="text" id="{{'see-other-pricing-options'+i}}" class="input silent-input" [value]="'0%'"
                       *ngIf="ist.MONTHS != 12" disabled>

                <!--<div class="new-percentage">
                  <span>%</span>
                </div>-->
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- total bottom -->
    <div class="row mt-5 p-3 text-center blue-border-top-2" *ngIf="false && currentReport && currentReport.LATEST">
      <div class="col-md-4">
        <span class="font-weight-bold color-secondary-gray font-size-20 mr-3 word-break__break-all">Projected
          Revenue</span>
        <span class="font-weight-bold color--basic--black">${{currentReport.LATEST.WEIGHTED_REVENUE | number}}</span>
      </div>
      <div class="col-md-4">
        <span class="font-weight-bold color-secondary-gray font-size-20 mr-3 word-break__break-all">Projected SDE</span>
        <span class="font-weight-bold color--basic--black">${{currentReport.LATEST.WEIGHTED_SDE | number}}</span>
      </div>
      <div class="col-md-4">
        <span class="font-weight-bold color-secondary-gray font-size-20 mr-3 word-break__break-all">Projected
          EBITDA</span>
        <span class="font-weight-bold color--basic--black">${{currentReport.LATEST.WEIGHTED_EBITDA | number}}</span>
      </div>
    </div>

    <!-- Cash flow warning -->
    <div class="mb-5 cashflow-warning" *ngIf="isCashFlowOverFifteenMillion">
      This tool is intended to value small businesses with cash flow less than $1,500,000.
    </div>
  </div>
</div>

<div class="custom-debug-window" *ngIf="showWeightingDebug">
  <div class="row">
    <div class="col-md-6" *ngIf="weightingDebugInformation?.revenueTrend?.trend">
      <label>Revenue Trend: </label> {{weightingDebugInformation.revenueTrend.trend}}
    </div>
    <div class="col-md-6" *ngIf="weightingDebugInformation?.revenueTrend?.fluctuateToValue">
      <label>Revenue Fluctuate To Value: </label> {{weightingDebugInformation.revenueTrend.fluctuateToValue}}
    </div>
    <div class="col-md-6" *ngIf="weightingDebugInformation?.sdeTrend?.trend">
      <label>SDE Trend: </label> {{weightingDebugInformation.sdeTrend.trend}}
    </div>
    <div class="col-md-6" *ngIf="weightingDebugInformation?.sdeTrend?.fluctuateToValue">
      <label>SDE Fluctuate To Value: </label> {{weightingDebugInformation.sdeTrend.fluctuateToValue}}
    </div>
    <div class="col-md-6" *ngIf="weightingDebugInformation?.numberOfYears">
      <label>Number Of Years: </label> {{weightingDebugInformation.numberOfYears}}
    </div>
    <div class="col-md-6" *ngIf="weightingDebugInformation?.interim">
      <label>Interim: </label> {{weightingDebugInformation.interim}}
    </div>
    <div class="col-md-6" *ngIf="weightingDebugInformation?.projectedMonths">
      <label>Projected Months: </label> {{weightingDebugInformation.projectedMonths}}
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-3">
      <div class="row">
        <div class="col-md-12">&nbsp;</div>
        <div class="col-md-12">
          <label>Revenue Trend Value: </label>
        </div>
        <div class="col-md-12">
          <label>Revenue Trend Score: </label>
        </div>
        <div class="col-md-12">
          <label>SDE Trend Value: </label>
        </div>
        <div class="col-md-12">
          <label>SDE Trend Score: </label>
        </div>
      </div>
    </div>
    <div class="col-md-2" *ngFor="let yr of weightingDebugInformation.years;">
      <div class="row">
        <div class="col-md-12">{{yr.year}}</div>
        <div class="col-md-12">
          <label> ${{yr.revenueTrendValue?.value | number}} </label>
        </div>
        <div class="col-md-12">
          <label> {{yr.revenueTrendValue?.score}} </label>
        </div>
        <div class="col-md-12">
          <label> ${{yr.sdeTrendValue?.value | number}} </label>
        </div>
        <div class="col-md-12">
          <label> {{yr.sdeTrendValue?.score}} </label>
        </div>
      </div>
    </div>
  </div>
</div>

<report-footer [nextBtnEnable]="(weightResultDetails?.WEIGHT_CALC_LIST && checkValidation() && !isCashFlowOverFifteenMillion) || currentReport?.isLocked"
  (buttonClicked)="footerButtonClick($event)" [skipBtnText]="isEditMode ? 'View Values' : 'Edit Values'"
               [mobileIcon]="isEditMode ? 'eye-icon' : 'edit-icon'"
  [skipAvailable]="!currentReport?.isLocked" [skipArrow]="false" [pageId]="reportPageConst.WEIGHTINGS">
</report-footer>
